export const generateGrid = ({
  xDiv = 2,
  yDiv = 2,
  width = 100,
  height = 100,
  xZoom = 1,
  yZoom = 1
} = {}) => {
  // decide block size
  var xSize = xDiv ? (width * xZoom) / xDiv : 0;
  var ySize = yDiv ? (height * yZoom) / yDiv : 0;
  if (!xSize) {
    xSize = ySize;
  }
  if (!ySize) {
    ySize = xSize;
  }
  if (!xSize && !ySize) {
    return [];
  }

  // decide margin
  const xMargin = (width - width * xZoom) / 2;
  const yMargin = (height - height * yZoom) / 2;

  const points = [];
  for (let x = xMargin; x < width * xZoom + xMargin; x += xSize) {
    for (let y = yMargin; y < height * yZoom + yMargin; y += ySize) {
      points.push({ x, y, alpha: Math.random() });
    }
  }
  return points;
};

export const generateArray = ({ from = 0, to = 100, steps = 10 } = {}) => {
  const arr = [];
  const step = (to - from) / steps;
  for (let i = 0; i < steps; i++) {
    arr.push(from + i * step);
  }
  return arr;
};

const scale = (num, in_min, in_max, out_min, out_max) => {
  return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
};

const normalize = (num, min, max) => {
  return scale(num, min, max, -1, 1);
};

const X_MIN = 0;
const X_MAX = 90;
const Y_MIN = -45;
const Y_MAX = 45;

const roundAndRememberForce = (x, y, size) => {
  const force = { x: Math.round(x * size), y: Math.round(y * size) };
  window._d17e_remember_force = force;
  return force;
};

export const getForce = ({ p = undefined, draw = false, size = 50 } = {}) => {
  if (!p) {
    return { x: 0, y: 0 };
  }
  if (p.rotationX) {
    if (p.rotationX === 0 && p.rotationY === 0 && window._d17e_remember_force) {
      // avoiding animation on page changes
      return window._d17e_remember_force;
    }
    const y = -normalize(
      Math.min(Math.max(p.rotationX, X_MIN), X_MAX),
      X_MIN,
      X_MAX
    );
    const x = normalize(
      Math.min(Math.max(p.rotationY, Y_MIN), Y_MAX),
      Y_MIN,
      Y_MAX
    );
    return roundAndRememberForce(x, y, size);
  }
  if (p.mouseX === 0 && p.mouseY === 0 && window._d17e_remember_force) {
    // avoiding animation on page changes
    return window._d17e_remember_force;
  }
  const x = -(p.mouseX * 2 - p.windowWidth) / p.windowWidth;
  const y = -(p.mouseY * 2 - p.windowHeight) / p.windowHeight;
  const force = roundAndRememberForce(x, y, size);
  if (draw) {
    drawForce(p, force, p.color(1, 255, 0));
  }
  return force;
};

export const getLerpedForce = ({
  p = undefined,
  draw = false,
  size = 50,
  lerp_millis = 1000
}) => {
  const force = getForce({ p, draw, size });
  if (
    !p.force_target ||
    p.force_target.x !== force.x ||
    p.force_target.y !== force.y
  ) {
    p.curr_force = p.curr_force || force;
    p.force_target = force;
    p.force_start_t = p.force_start_t
      ? // making sure we've alwasy got some movement (none at 0)
        p.millis() - lerp_millis / 4
      : // and no movement on switching pages
        p.millis() - lerp_millis;
  }
  // clamp deltatime (dt) to 0-1 range
  const dt = Math.max(
    0,
    Math.min(1, (p.millis() - p.force_start_t) / lerp_millis)
  );
  p.curr_force = {
    x: p.lerp(p.curr_force.x, p.force_target.x, dt),
    y: p.lerp(p.curr_force.y, p.force_target.y, dt)
  };
  return p.curr_force;
};

export const getDocumentScrollHeight = () => {
  if (!document) {
    return 0;
  }
  let bodies = document.getElementsByTagName('html');
  if (!bodies || bodies.length === 0) {
    return 0;
  }
  return bodies[0].scrollHeight;
};

const drawForce = (p, force, color) => {
  p.push();
  p.stroke(color);
  const start = { x: p.windowWidth / 2, y: p.windowHeight / 2 };
  p.line(start.x, start.y, start.x + force.x, start.y + force.y);
  p.pop();
};

export const randomInt = max => {
  return Math.floor(Math.random() * Math.floor(max));
};
